import { EuiFormControlLayout } from "@elastic/eui";
import { SearchIcon } from "components/Icons";
import { FC, useRef, useState } from "react";
import { createUseStyles } from "react-jss";

interface SearchButtonProps {
  onSearch: (seatrchTerm: string) => void;
}

const useStyles = createUseStyles({
  searchButton: {},
  customSearchInput: {
    lineHeight: "2.15rem",
    borderRadius: "8px !important",
    fontWeight: 400,
    border: "1px solid var(--border-color)",
    paddingLeft: 35,
    backgroundColor: "var(--card-background)",
    color: "var(--text)",
    outline: "none",
    boxShadow: "none",

    "&:focus": {
      outline: "none !important",
      boxShadow: "none !important",
      borderColor: "var(--border-color) !important",
    },

    "&:active": {
      outline: "none !important",
      boxShadow: "none !important",
    },

    "&:focus-visible": {
      outline: "none !important",
      boxShadow: "none !important",
    },

    formControlLayout: {
      "&:focus-within": {
        boxShadow: "none !important",
      },
    },
  },
  searcherWrapper: {
    padding: "6px",
    paddingBottom: 0,
    "& hr": {
      visibility: "hidden",
    },
    "&:hover": {
      "& hr": {
        position: "relative",
        border: "1px solid black",
        visibility: "visible",
      },
    },
  },
});
const SearchIconRender = () => <SearchIcon />;
const SearchButton: FC<SearchButtonProps> = ({ onSearch }) => {
  const classes = useStyles();
  const inputRef: any = useRef();
  const [searchBoxVisible, setSearchBoxVisible] = useState(false);
  const textSearchDelayTimer: any = useRef(null);
  const [filterText, setFilterText] = useState<string>(""); //tmp while typing

  return (
    <div className={classes.searchButton} data-testid="SearchButton">
      {!searchBoxVisible && (
        <>
          <div
            className={classes.searcherWrapper}
            onClick={() => {
              setSearchBoxVisible((v) => {
                const newState = !v;
                if (newState) {
                  setTimeout(() => {
                    if (inputRef.current && typeof inputRef?.current?.focus === "function") {
                      inputRef.current.focus();
                    }
                  }, 100);
                }

                return newState;
              });
            }}>
            <SearchIcon color="var(--text)" />
            <hr></hr>
          </div>
        </>
      )}

      {searchBoxVisible && (
        <>
          <EuiFormControlLayout
            clear={{
              onClick: () => {
                if (textSearchDelayTimer.current) {
                  clearTimeout(textSearchDelayTimer.current);
                }
                setFilterText("");
                onSearch("");
                setSearchBoxVisible(false);
              },
            }}
            compressed
            icon={SearchIconRender}>
            <input
              className={`euiFieldSearch euiFieldSearch--compressed ${classes.customSearchInput}`}
              data-test-subj="table-search-text"
              onChange={(e) => {
                if (textSearchDelayTimer.current) {
                  clearTimeout(textSearchDelayTimer.current);
                }
                const val = e.target.value;
                setFilterText(val);

                textSearchDelayTimer.current = setTimeout(() => {
                  if (val.length > 1) {
                    onSearch(val);
                  }
                }, 500);
              }}
              onKeyUp={(e: any) => {
                const val = e.target.value;
                if (val === "" && e.key !== "Enter") {
                  if (textSearchDelayTimer.current) {
                    clearTimeout(textSearchDelayTimer.current);
                  }
                  onSearch("");
                }
              }}
              placeholder="Search ..."
              ref={inputRef}
              type="search"
              value={filterText}
            />
          </EuiFormControlLayout>
        </>
      )}
    </div>
  );
};

export default SearchButton;
